import {
  CONSENT_CATEGORY_ANALYTICS,
  CONSENT_CATEGORY_MARKETING,
  ConsentCategoryInfo,
  ConsentPreferences
} from "./types";

import { hasPrivacySignal } from "./utils/hasPrivacySignal";

export const CONSENT_STORAGE_KEY = "cookie-consent";

export const CONSENT_CHANGED_EVENT = "wingspan:cookie-consent-changed";

export const DEFAULT_CONSENT_PREFERENCES: ConsentPreferences = {
  [CONSENT_CATEGORY_MARKETING]: !hasPrivacySignal(),
  [CONSENT_CATEGORY_ANALYTICS]: !hasPrivacySignal()
};
